/* CM OPT03 · C3 (3-nov-2026). «También te puede servir» (+) y «Complétalo» (el par): total según la forma de compra
   elegida en la caja (compra única o suscripción), línea del envío gratis y «Agregar los dos», que suma los dos al
   panel lateral del carrito con su plan de venta. Usa la API pública de Instant (regla 22b). Ver cm-complementos.liquid. */
(function () {
  var box = document.querySelector('[data-cm-c3]');
  if (!box || box.getAttribute('data-cm-listo')) return;
  box.setAttribute('data-cm-listo', '1');
  var ES = box.getAttribute('data-lang') === 'es';
  var UMBRAL = parseInt(box.getAttribute('data-umbral'), 10) || 7500;
  var root = box.closest('form[data-instant-type="root"], [data-instant-type="root"]') || document;
  var SABOR_ES = { vanilla: 'Vainilla', coffee: 'Café', chocolate: 'Chocolate', matcha: 'Matcha' };

  function dinero(c) {
    try { if (window.Instant && Instant.api && Instant.api.formatMoney) return Instant.api.formatMoney(c); } catch (e) {}
    return '$' + (c / 100).toFixed(2);
  }
  function txt(el, v) { if (el && el.textContent !== v) el.textContent = v; }

  /* Sabores del compañero en español (los nombres vienen de Shopify en inglés) */
  var sel = box.querySelector('[data-cm-sabor]');
  if (sel && ES) [].forEach.call(sel.options, function (o) { var k = o.textContent.trim().toLowerCase(); if (SABOR_ES[k]) o.textContent = SABOR_ES[k]; });

  var yo = {};
  try { yo = JSON.parse((box.querySelector('[data-cm-yo-datos]') || {}).textContent || '{}').variantes || {}; } catch (e) { yo = {}; }

  /* Estado de la caja de compra */
  function varianteYo() {
    var a = root.querySelector('a.trigger__sticky[data-instant-action-variant-id]') || root.querySelector('[data-instant-action-type="add-to-instant-cart"][data-instant-action-variant-id]');
    var id = (a && a.getAttribute('data-instant-action-variant-id')) || (root.getAttribute && root.getAttribute('data-instant-form-variant-id'));
    if (!id || !yo[id]) id = Object.keys(yo)[0];
    return id;
  }
  function planElegido() {
    var act = root.querySelector('.instant-selling-plan-selector[data-instant-state="active"]');
    var id = act && act.getAttribute('data-instant-selling-plan-id');
    return (!id || id === 'one-time-purchase') ? null : id;
  }
  function compania() {
    if (sel) return sel.options[sel.selectedIndex];
    return box.querySelector('[data-cm-sabor-fijo]');
  }

  var ultimo = '';
  function actualizar() {
    var vid = varianteYo(), v = yo[vid] || {}, plan = planElegido(), sub = !!plan;
    var p1 = v.p || 0, sp1 = null;
    if (sub) {
      var planes = v.planes || {};
      if (planes[plan] != null) { p1 = planes[plan]; sp1 = plan; }
      else { var k = Object.keys(planes)[0]; if (k) { p1 = planes[k]; sp1 = k; } else sub = false; }
    }
    var c = compania();
    if (!c) return;
    var p2 = parseInt(c.getAttribute('data-p'), 10) || 0, sp2 = c.getAttribute('data-sp') || null;
    if (sub && sp2) p2 = parseInt(c.getAttribute('data-spp'), 10) || p2; else sp2 = null;
    var tot = p1 + p2, falta = UMBRAL - tot;
    var clave = [vid, plan, c.value, tot].join('|');
    if (clave === ultimo) return;
    ultimo = clave;
    box._cm = { yo: vid, sp1: sub ? sp1 : null, comp: c.value, sp2: sub ? sp2 : null };
    txt(box.querySelector('[data-cm-yo-pre]'), dinero(p1));
    txt(box.querySelector('[data-cm-comp-pre]'), dinero(p2));
    txt(box.querySelector('[data-cm-total]'), dinero(tot));
    txt(box.querySelector('[data-cm-btn-total]'), dinero(tot));
    txt(box.querySelector('[data-cm-total-txt]'), sub ? (ES ? 'Total del par con suscripción' : 'Pair total with subscription') : (ES ? 'Total del par' : 'Pair total'));
    txt(box.querySelector('[data-cm-envio]'), falta <= 0 ? (ES ? '✓ Con este par tu envío es gratis' : '✓ This pair ships free')
      : (ES ? 'Te faltan ' + dinero(falta) + ' para el envío gratis' : "You're " + dinero(falta) + ' away from free shipping'));
    var img = box.querySelector('[data-cm-yo] img');
    if (img && v.img && img.getAttribute('data-cm-src') !== v.img) { img.setAttribute('data-cm-src', v.img); img.removeAttribute('srcset'); img.src = v.img; }
    var cimg = box.querySelector('[data-cm-comp] img'), ci = c.getAttribute('data-img');
    if (cimg && ci && cimg.getAttribute('data-cm-src') !== ci) { cimg.setAttribute('data-cm-src', ci); cimg.removeAttribute('srcset'); cimg.src = ci; }
  }

  if (sel) sel.addEventListener('change', actualizar);
  /* La caja de compra de Instant cambia el plan o la variante marcando atributos: se escuchan sin escribir de más */
  new MutationObserver(function () { actualizar(); }).observe(root, { subtree: true, attributes: true, attributeFilter: ['data-instant-state', 'data-instant-action-variant-id', 'data-instant-form-variant-id'] });
  actualizar();

  function agregar(items, boton) {
    if (window.Instant && Instant.api && Instant.api.addToCart) return Instant.api.addToCart(items, { openCart: true, button: boton });
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items.map(function (i) { var o = { id: i.id, quantity: i.quantity }; if (i.sellingPlan) o.selling_plan = i.sellingPlan; return o; }) })
    }).then(function (r) { if (r.ok) location.href = '/cart'; return { success: r.ok }; });
  }

  box.addEventListener('click', function (e) {
    var mas = e.target.closest('[data-cm-mas]');
    if (mas && !mas.disabled) { e.preventDefault(); agregar([{ id: parseInt(mas.getAttribute('data-cm-mas'), 10), quantity: 1 }], mas); return; }
    var dos = e.target.closest('[data-cm-dos]');
    if (dos && !dos.disabled) {
      e.preventDefault(); actualizar(); var s = box._cm; if (!s) return;
      var a = { id: parseInt(s.yo, 10), quantity: 1 }, b = { id: parseInt(s.comp, 10), quantity: 1 };
      if (s.sp1) a.sellingPlan = parseInt(s.sp1, 10);
      if (s.sp2) b.sellingPlan = parseInt(s.sp2, 10);
      agregar([a, b], dos).then(function (r) { if (r && r.success === false) console.warn('[CM C3] no se pudo agregar el par', r.error); });
    }
  });
})();
